import { useState, useEffect, useRef } from 'react';
import { Stack, Typography, LinearProgress, Button } from '@mui/material';
import { Header } from '../shared/Header';
import { useParams } from 'react-router';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../global/constants';
import { AzureUploader } from '../../helpers/Azure-Uploader';

const GENERIC_UPLOAD_STATUS_MESSAGE =
	'We are unable to save your recording right now. Our team will review this automatically.';
const SLOW_UPLOAD_STATUS_MESSAGE = 'Saving is taking longer than expected. Please wait...';

export const EndCodingScreen = () => {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const interviewKey = params?.interview_key;
	const fullName = params?.fullName;
	const isDemo = location?.state?.isDemo;
	const [videoUploadPercentage, setVideoUploadPercentage] = useState(0);
	const [isVideoUploaded, setVideoUploaded] = useState(false);
	const [uploadStatusMessage, setUploadStatusMessage] = useState('');
	const [isInterviewRequired, setIsInterviewRequired] = useState(false);
	const uploaderRef = useRef(null);
	const pendingUploadRef = useRef(null);
	const uploadRetryCountRef = useRef(0);
	const retryTimeoutRef = useRef(null);
	const MAX_UPLOAD_RETRIES = 3;
	const UPLOAD_RETRY_DELAY_MS = 2000;
	useEffect(() => {
		async function fetchinterview() {
			const data = await axios.get(`${API_URL}/labs/interview/${interviewKey}`);
			const interviewdetails = data.data;
			const is_interview_required =
				interviewdetails?.candidate_interview?.is_interview_required;
			console.log(is_interview_required, 'xy');
			setIsInterviewRequired(is_interview_required);
		}
		fetchinterview();
	}, []);

	useEffect(() => {
		console.log('Recorder:', window?.videoRecorderRef);
		console.log('Stream:', window?.videoStream);
		const videoRecorderRef = window?.videoRecorderRef;
		const videoStream = window?.videoStream;
		if (!videoRecorderRef?.current || !videoStream) {
			setUploadStatusMessage(GENERIC_UPLOAD_STATUS_MESSAGE);
			return;
		}

		if (videoRecorderRef && videoStream) {
			videoRecorderRef.current.stopRecording(() => {
				const blob = videoRecorderRef.current.getBlob();
				if (!blob || blob.size === 0) {
					setUploadStatusMessage(GENERIC_UPLOAD_STATUS_MESSAGE);
					return;
				}
				console.log('BLOB size:', blob?.size);
				videoStream.getTracks().forEach(function (track) {
					track.stop();
				});
				const date = new Date();
				let fileName = `${interviewKey}/videos/coding-${date.getTime()}`;
				const url_file = new File([blob], `${fileName}.webm`, {
					type: 'video/webm',
				});
				console.log('url_file', url_file);
				pendingUploadRef.current = {
					file: url_file,
					fileName,
					videoType: 'candidateCodingVideo',
				};
				uploadVideoToS3(url_file, fileName, 'candidateCodingVideo');
			});
		}
	}, []);

	useEffect(() => {
		return () => {
			uploaderRef.current?.abort();
			if (retryTimeoutRef.current) {
				clearTimeout(retryTimeoutRef.current);
			}
		};
	}, []);

	const uploadVideoToS3 = async (ev, fileName, videoType, isRetry = false) => {
		if (ev) {
			if (!ev.size) {
				setUploadStatusMessage(GENERIC_UPLOAD_STATUS_MESSAGE);
				return;
			}

			if (!isRetry) {
				uploadRetryCountRef.current = 0;
				setUploadStatusMessage('');
				setVideoUploaded(false);
				setVideoUploadPercentage(0);
			}

			//setShowLastScreen(true);
			const videoUploaderOptions = {
				fileName: `${fileName}`,
				file: ev,
				videoType,
			};

			let percentage = -1;

			const uploader = new AzureUploader(videoUploaderOptions);
			uploaderRef.current = uploader;

			uploader
				.onProgress(({ percentage: newPercentage }) => {
					// to avoid the same percentage to be logged twice
					const safePercentage = Math.max(
						0,
						Math.min(99, Number.isFinite(newPercentage) ? newPercentage : 0)
					);

					if (safePercentage !== percentage) {
						percentage = safePercentage;
						setVideoUploadPercentage(percentage);
					}
				})
				.onError((error) => {
					console.error(error);
					uploaderRef.current = null;

					if (uploadRetryCountRef.current < MAX_UPLOAD_RETRIES) {
						uploadRetryCountRef.current += 1;
						setUploadStatusMessage(SLOW_UPLOAD_STATUS_MESSAGE);

						if (retryTimeoutRef.current) {
							clearTimeout(retryTimeoutRef.current);
						}

						retryTimeoutRef.current = setTimeout(() => {
							const pendingUpload = pendingUploadRef.current;
							if (!pendingUpload) {
								setUploadStatusMessage(GENERIC_UPLOAD_STATUS_MESSAGE);
								return;
							}

							uploadVideoToS3(
								pendingUpload.file,
								pendingUpload.fileName,
								pendingUpload.videoType,
								true
							);
						}, UPLOAD_RETRY_DELAY_MS);

						return;
					}

					setUploadStatusMessage(GENERIC_UPLOAD_STATUS_MESSAGE);
				})
				.onComplete(() => {
					if (retryTimeoutRef.current) {
						clearTimeout(retryTimeoutRef.current);
						retryTimeoutRef.current = null;
					}
					uploadRetryCountRef.current = 0;
					setUploadStatusMessage('');
					setVideoUploadPercentage(100);
					setVideoUploaded(true);
					uploaderRef.current = null;
				});

			await uploader.start();
		}
	};

	const goToNextSection = () => {
		const navigateTo = location?.state?.isStudentInterview ? 'college' : 'company';
		navigate(`/interview/${navigateTo}/${fullName}/${interviewKey}`, {
			state: {
				interviewKey: interviewKey,
				fullName: fullName,
				isDemo,
				isStudentInterview: location?.state?.isStudentInterview,
			},
		});
	};

	return (
		<>
			<Header fullName={fullName} />
			<Stack
				// m={0}
				// p={3}
				width="100vw"
				display="flex"
				// justifyContent="center"
				alignItems="center"
				flexDirection="column"
				textAlign="center"
				bgcolor="#ecf7fa"
			>
				<Stack
					direction={'column'}
					justifyContent={'center'}
					alignItems={'center'}
					spacing={1}
					sx={{
						paddingTop: '20px',
						paddingBottom: '20px',
						// position: "fixed",
						top: 0,
						width: '100%',
					}}
					bgcolor={isVideoUploaded ? 'green' : '#232333'}
					color="#ffffff"
				>
					{!isVideoUploaded && (
						<>
							<Typography
								id="modal-modal-title"
								variant="h6"
								component="h2"
								display={'flex'}
								fontFamily={'Poppins'}
								alignItems={'center'}
								fontSize={'2.7rem'}
							>
								Please Wait...
							</Typography>
							{/* <CircularProgress /> */}
							<Typography>
								{videoUploadPercentage && `${videoUploadPercentage} % uploaded...`}
							</Typography>
							{uploadStatusMessage && (
								<Typography color={'#ffd54f'} fontWeight={'bold'}>
									{uploadStatusMessage}
								</Typography>
							)}
							<LinearProgress
								variant="determinate"
								value={videoUploadPercentage}
								style={{ width: '350px', height: '15px', borderRadius: '10px' }}
							/>
							<Typography fontSize={'1.5rem'}>While we save your answers</Typography>
							<Typography fontSize={'1.5rem'}>
								It usually takes 1 - 2 minutes
							</Typography>
							<Typography color={'red'} fontWeight={'bold'} fontSize={'1.5rem'}>
								Do not close this window
							</Typography>
						</>
					)}
					{isVideoUploaded && isInterviewRequired && (
						<>
							<Typography
								variant="h5"
								color="#ffffff"
								mt={3}
								ml={2}
								mr={2}
								//className={styles.feedbackSecondaryHeader}
							>
								Your answers were saved successfully!!
							</Typography>
							<Typography
								variant="h5"
								color="#ffffff"
								mt={3}
								ml={2}
								mr={2}
								//className={styles.feedbackSecondaryHeader}
							>
								Please click on "Go to Next Section" to start next round
							</Typography>
							<Button
								variant="outlined"
								onClick={goToNextSection}
								style={{
									textTransform: 'none',
								}}
								sx={{
									textTransform: 'none',
									color: '#FFFFFF',
									'&:hover': {
										backgroundColor: '#224C84',
										color: 'white',
										border: '1px solid #FFFFFF',
									},
									border: '1px solid #FFFFFF',
								}}
							>
								{' '}
								Go to Next Section
							</Button>
						</>
					)}
					{isVideoUploaded && !isInterviewRequired && (
						<>
							<Typography
								variant="h5"
								color="#ffffff"
								mt={3}
								ml={2}
								mr={2}
								//className={styles.feedbackSecondaryHeader}
							>
								Your answers were saved successfully!! you can close the window
							</Typography>
						</>
					)}
				</Stack>
				{isInterviewRequired && (
					<Stack
						direction={'column'}
						justifyContent={'center'}
						alignItems={'center'}
						m={2}
						spacing={1}
						// sx={{ paddingTop: "20px", paddingBottom: "20px" }}
						bgcolor="#ecf7fa"
					>
						<Typography
							id="modal-modal-title"
							variant="h6"
							component="h2"
							display={'flex'}
							fontFamily={'Poppins'}
							alignItems={'center'}
						>
							Tips for AI.HYR's Video Interview
						</Typography>
						<Stack bgcolor="#ffffff" p={3} mt={3} mb={3} borderRadius={4}>
							<p>1. Be relaxed and talk confidently</p>
							<p>2. Take pauses to re-collect your thoughts</p>
							<p>3. Be yourself. We just want to get to know you better</p>
						</Stack>
					</Stack>
				)}
			</Stack>
		</>
	);
};
